var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.flattenedSectors && _vm.flattenedSectors.length
    ? _c("div", { staticClass: "sector-popup" }, [
        _c("span", {
          staticClass: "sector-popup__label",
          domProps: { textContent: _vm._s(_vm.label) },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "sector-popup__dropdown" }, [
          _c(
            "div",
            { staticClass: "sector-popup__items" },
            _vm._l(_vm.flattenedSectors, function (sector) {
              return _c("span", {
                staticClass: "sector",
                domProps: { textContent: _vm._s(sector.label) },
              })
            }),
            0
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }